import React, { useState, useEffect } from "react";

//package import

import { Backdrop, CircularProgress, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ActionCableProvider } from "react-actioncable-provider";

//user import

import { PouAdminLayout } from "../../layouts";
import { hospital_Context } from "../../context";
import { StorageKeys } from "../../Services/Storage";
import { POU_API_ULRS, API_WS_ROOT } from "../../Services/Routes/API";
import { RoutesUrls } from "../../Services/Routes/APP";
import { headersPost } from "../../Services/API";
//portal

const PouAdminPortal = (props) => {
	//hooks

	const navigate = useNavigate();
	const theme = useTheme();

	//constants

	const Provider = hospital_Context.Provider;
	//provinces
	const [hospitals, setHospitals] = useState([]);
	const [open, setOpen] = useState(false);

	const token = localStorage.getItem(StorageKeys?.token);

	//

	useEffect(() => {
		getHospitals();
	}, []);

	//get hospitals

	const getHospitals = () => {
		const data = {
			page: 1,
			per_page: 50,
		};
		setOpen(true);

		headersPost(POU_API_ULRS.GET_ALL_POU, data)
			.then((res) => {
				setOpen(false);
				if (res?.status === 200 && res?.data?.success) {
					setHospitals(res?.data?.hospitals);
					// setTotalCount(res?.data?.total_count);
				} else {
					// setAlertOpen(true);
					// setAlertMsg(res?.data?.message);
					// setAlertIcon("warning");
				}
			})
			.catch((err) => {
				setOpen(false);
				const { response } = err;
				if (response?.status === 401) {
					localStorage.clear();
					navigate(RoutesUrls?.root);
				} else {
					// setAlertOpen(true);
					// setAlertMsg(response?.statusText);
					// setAlertIcon("error");
				}
			});
	};
	return (
		<Provider
			value={{
				pou: hospitals,
				user: { ...token },
			}}
		>
			<ActionCableProvider url={API_WS_ROOT + `?token=${token}`}>
				<PouAdminLayout {...props} />
			</ActionCableProvider>
			<Backdrop
				sx={{
					zIndex: theme.zIndex.drawer + 1,
					color: theme.palette.primary.main,
				}}
				open={open}
			>
				<CircularProgress color="inherit" />
			</Backdrop>
		</Provider>
	);
};

export default PouAdminPortal;
